import { Routes, Route } from "react-router-dom";
import Home from "../Pages/Home";
import Trabajos from "../Pages/Trabajos";
import Contacto from "../Pages/Contacto";


function Public(){
    return(
        <>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/trabajos" element={<Trabajos/>}/>
                <Route path="/contacto" element={<Contacto/>}/>
            </Routes>
        </>
    )
}

export default Public;